module.exports = __webpack_public_path__ + "img/pewdiepie.89de37fd.png";